import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";
import SiteFooter from "../components/SiteFooter";

const COMPANY_INFO = [
  ["Ragione Sociale", "CMP ELETTROMECCANICA S.R.L."],
  ["Sede legale", "Via Isonzo 2/A – 24040 Comun Nuovo (BG)"],
  ["Partita IVA", "04565850163"],
  ["Codice fiscale", "04565850163"],
  ["Registro delle Imprese", "Bergamo"],
  ["Numero REA", "BG 472657"],
  ["Capitale sociale", "€ 50.000"],
  ["PEC", "cmpelettromeccanicasrl@arubapec.it", "mailto:cmpelettromeccanicasrl@arubapec.it"],
  ["Email", "info@cmpelettromeccanica.it", "mailto:info@cmpelettromeccanica.it"],
  ["Stato della società", "Attiva"],
  ["Società a socio unico", "Sì"],
  ["Attività di direzione e coordinamento", "La società non è soggetta ad attività di direzione e coordinamento da parte di altre società o enti."],
];

export default function CompanyInfoPage() {
  const navigate = useNavigate();
  const handleBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <div className="min-h-screen bg-slate-50">
      <Seo
        title="Informazioni societarie"
        description="Informazioni societarie di CMP ELETTROMECCANICA S.R.L., società che gestisce la piattaforma quandomiserve.it."
        canonical="https://www.quandomiserve.it/informazioni-societarie"
      />
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-3 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between gap-2">
            <Button onClick={handleBack} variant="ghost" size="sm" className="text-slate-600 hover:text-slate-900 px-2 sm:px-3" data-testid="company-info-back-btn">
              <ArrowLeft className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Torna indietro</span>
              <span className="sm:hidden">Indietro</span>
            </Button>
            <img src="/logo-quandomiserve-dark.png" alt="quandomiserve.it" className="h-8 sm:h-10 w-auto object-contain" />
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-3 sm:px-6 py-8 sm:py-12">
        <div className="bg-white rounded-lg shadow-sm p-5 sm:p-8" data-testid="company-info-page">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">Informazioni societarie</h1>
          <p className="text-sm text-slate-500 mb-6">Società che gestisce la piattaforma</p>
          <dl className="divide-y divide-slate-100 border border-slate-100 rounded-lg bg-slate-50">
            {COMPANY_INFO.map(([label, value, href]) => (
              <div key={label} className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4 px-4 py-3 sm:px-5">
                <dt className="text-sm font-medium text-slate-500">{label}</dt>
                <dd className="sm:col-span-2 text-sm text-slate-900 break-words" data-testid={`company-info-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {href ? <a href={href} className="text-orange-600 hover:underline">{value}</a> : value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
